import _ from "lodash";
import ACLStore from "lib/aclStore";
const STUDENT_ALERT_TYPE_MAPPING_FEATURE_FLAG =
  "FeatureFlag:StudentAlertTypeMappingEnabled";

// Check if student alert type mapping feature is enabled
export const isStudentAlertTypeMappingFeatureEnabled = () =>
  ACLStore.can(STUDENT_ALERT_TYPE_MAPPING_FEATURE_FLAG);

export const getStudentAlertsNomenclature = ({ t } = {}) => {
  // TODO: Replace hardcoded values with query cache once BE support is added
  const globalConstants = [
    {
      name: "ALERTS_MODULE_NOMENCLATURE_ALERT",
      value: t ? t("studentAlert:flag") : "Flag",
    },
    {
      name: "ALERTS_MODULE_NOMENCLATURE_MODULE",
      value: t ? t("studentAlert:student_flag") : "Student flag",
    },
  ];

  const NOMENCLATURE_NAME_MAP = {
    ALERTS_MODULE_NOMENCLATURE_ALERT: "alert",
    ALERTS_MODULE_NOMENCLATURE_MODULE: "module",
  };

  const NOMENCLATURE_FALLBACK_MAP = {
    [NOMENCLATURE_NAME_MAP.ALERTS_MODULE_NOMENCLATURE_ALERT]: "Alert",
    [NOMENCLATURE_NAME_MAP.ALERTS_MODULE_NOMENCLATURE_MODULE]: "Student alerts",
  };

  const nomenclatureConstants = _.reduce(
    globalConstants,
    (acc, item) => {
      const { name, value } = item;
      const customName = NOMENCLATURE_NAME_MAP[name];

      if (!customName) {
        return acc;
      }

      return {
        ...acc,
        [customName]: value,
      };
    },
    {}
  );

  _.forEach(NOMENCLATURE_FALLBACK_MAP, (fallbackValue, nomenclatureKey) => {
    if (_.isEmpty(nomenclatureConstants[nomenclatureKey])) {
      nomenclatureConstants[nomenclatureKey] = fallbackValue;
    }
  });

  return nomenclatureConstants;
};

export const getStudentAlertTypeColumnList = ({
  serviceName,
  t,
  nomenclatureConstants,
}) => {
  return [
    {
      label: t("integration:toddle_alert_types_with_label", {
        ...nomenclatureConstants,
      }),
      id: "toddleAlertType",
      type: "TEXTCOLUMN",
      isSticky: true,
      style: {
        width: "50%",
      },
    },
    {
      label: t("integration:alert_types_with_service_and_label", {
        ...nomenclatureConstants,
        service: serviceName,
      }),
      id: "sisAlertTypeDropdown",
      type: "CUSTOM",
      isSticky: true,
      style: {
        width: "50%",
      },
    },
  ];
};

export const generateDataForStudentAlertTypeList = ({ toddleAlertTypes }) => {
  return _.map(toddleAlertTypes, alert => ({
    id: alert.id,
    toddleAlertId: alert.id,
    toddleAlertType: alert.name,
    sisAlertTypeDropdown: {
      toddleAlertId: alert.id,
    },
  }));
};

export const getSisAlertTypeDropdownOptions = _.memoize(
  ({ sisAlertTypes = [] }) => {
    return _.map(sisAlertTypes, alert => ({
      value: alert.id,
      label: alert.value?.description || alert.value?.name,
    }));
  },
  JSON.stringify
);

export const getFilteredSisAlertTypeOptions = ({
  sisAlertTypes,
  mappingsState,
  toddleAlertId,
}) => {
  const allOptions = getSisAlertTypeDropdownOptions({ sisAlertTypes });
  const selectedInOtherRows = _.uniq(
    _.flatten(_.values(_.omit(mappingsState, toddleAlertId)))
  );
  return _.filter(
    allOptions,
    option => !_.includes(selectedInOtherRows, option.value)
  );
};
